import { IResponse, IResponsePaginateRaw, PassingMode, PassingModeDto, WithMetadata } from '@/types';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseQueryParams } from '@/types/generic-responses.types';

@Injectable({
  providedIn: 'root',
})
export class PassingModeService {
  BASEURL = `${environment.api.paramsUrl}/mode_passation`;
  httpClient = inject(HttpClient);

  getAll(params?: BaseQueryParams): Observable<IResponsePaginateRaw<PassingMode>> {
    return this.httpClient.get<IResponsePaginateRaw<PassingMode>>(this.BASEURL, { params: params as HttpParams });
  }

  getOne(id: number): Observable<WithMetadata<PassingMode>> {
    return this.httpClient.get<WithMetadata<PassingMode>>(`${this.BASEURL}/${id}`);
  }

  getByMarketType(marketType: number): Observable<IResponse<PassingMode>> {
    return this.httpClient.get<IResponse<PassingMode>>(`${this.BASEURL}/type_marcher/${marketType}`);
  }

  list(): Observable<IResponse<PassingMode>> {
    return this.httpClient.get<IResponse<PassingMode>>(`${this.BASEURL}/list`);
  }

  add(passingMode: PassingModeDto): Observable<WithMetadata<PassingMode>> {
    return this.httpClient.post<WithMetadata<PassingMode>>(`${this.BASEURL}`, passingMode);
  }

  update(id: number, passingMode: PassingModeDto): Observable<WithMetadata<PassingMode>> {
    return this.httpClient.put<WithMetadata<PassingMode>>(`${this.BASEURL}/${id}`, passingMode);
  }

  delete(id: number): Observable<WithMetadata<PassingMode>> {
    return this.httpClient.delete<WithMetadata<PassingMode>>(`${this.BASEURL}/${id}`);
  }
}
